import React from 'react';
import { Waves, Sparkles, FlaskConical, Recycle, Wrench, Droplets } from 'lucide-react';
export function ServicesOverview() {
  const services = [{
    icon: <Waves size={24} data-id="element-183" />,
    title: 'Complete Weekly Service',
    description: 'Full maintenance including water treatment, filter cleaning, and debris removal. Starting at $129.99/month.'
  }, {
    icon: <Sparkles size={24} data-id="element-184" />,
    title: 'One-Time Pool Service',
    description: 'Deep clean before a party, after a long season, or whenever you need it.'
  }, {
    icon: <FlaskConical size={24} data-id="element-185" />,
    title: 'Chemical-Only Service',
    description: 'Chemistry balancing handled by a certified pro. You handle the rest.'
  }, {
    icon: <Recycle size={24} data-id="element-186" />,
    title: 'Green to Clean Recovery',
    description: 'Severe algae or neglect? We restore it fast.'
  }, {
    icon: <Wrench size={24} data-id="element-187" />,
    title: 'Pool Filter Cleaning & Repair',
    description: 'Clean filters, inspected equipment, and filter installations.'
  }, {
    icon: <Droplets size={24} data-id="element-188" />,
    title: 'Green Pool & Draining',
    description: 'Full drain, acid wash, or remediation for serious pool conditions.'
  }];
  return <section id="services" className="py-12 md:py-20 bg-brand-light relative" data-id="element-189">
      <div className="container mx-auto px-6 md:px-8" data-id="element-190">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16" data-id="element-191">
          <div className="inline-block bg-brand-teal text-white text-xs font-bold tracking-wider uppercase px-4 py-1.5 rounded-full mb-6" data-id="element-192">
            What We Do
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-text mb-4" data-id="element-193">
            Everything your pool needs, nothing more.
          </h2>
          <p className="text-lg text-brand-muted" data-id="element-194">
            From routine weekly maintenance to green pool recovery, we handle it
            all.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-195">
          {services.map((service, index) => <div key={index} className="bg-white rounded-xl p-6 md:p-8 shadow-soft border-l-4 border-brand-teal flex flex-col h-full transition-transform hover:-translate-y-1 duration-300" data-id="element-196">
              <div className="w-12 h-12 rounded-full bg-brand-light text-brand-teal flex items-center justify-center mb-6" data-id="element-197">
                {service.icon}
              </div>
              <h3 className="text-xl font-heading font-bold text-brand-text mb-3" data-id="element-198">
                {service.title}
              </h3>
              <p className="text-brand-muted leading-relaxed" data-id="element-199">
                {service.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-200">
          <a href="#contact" className="inline-flex bg-brand-amber text-white px-8 py-4 rounded-full font-semibold hover:bg-brand-amber/90 transition-colors min-h-[48px] items-center justify-center shadow-soft w-full sm:w-auto" data-id="element-201">
            Request a Custom Quote
          </a>
        </div>
      </div>
    </section>;
}